import React from "react";
import { Descriptions } from "antd";
import formatDate from "utilities/formats/formatDate";

const RequestContent = ({
  clinicNo,
  equipment,
  requestType,
  currentStatus,
  requestDate,
  sourceClinicNo,
  estimatedCost
}) => {
  const items = [
    {
      label: "Request Type",
      children: requestType,
      span: {
        lg: 2,
        xl: 2,
        xxl: 2,
      },
    },
    {
      label: "Current Status", // New field for current status
      children: currentStatus,
      span: 1,
    },
    {
      label: "Request Date", // New field for request date
      children: formatDate(requestDate),
      span: 1,
    },
    {
      label: "Clinic",
      children: requestType === "Transfer" ? sourceClinicNo + ' → ' + clinicNo : clinicNo,
      span: 1,
    },
    {
      label: "Brand",
      children: equipment.brand,
    },
    {
      label: "Model",
      children: equipment.model,
    },
    {
      label: "Category",
      children: equipment.category,
    },
    ...estimatedCost
      ? [
          {
            label: "Estimated Cost",
            children: `$${estimatedCost}`,
          },
        ]
      : [],
  ];

  return (
    <Descriptions
      colon={false}
      layout="vertical"
      column={{
        xs: 1,
        sm: 2,
        md: 3,
        lg: 3,
        xl: 4,
        xxl: 4,
      }}
      items={items}
    />
  );
};

export default RequestContent;
